import { Outlet } from "react-router-dom";
import { ErrorBoundary, ErrorBoundaryGroup } from "@suspensive/react";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { AppHeader } from "@/components/layout/AppHeader";
import { SidebarProvider } from "@/components/ui/sidebar";
import { PageErrorFallback } from "@/components/error-boundary/error-fallback";

export function AdminLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className="flex flex-1 flex-col">
          <AppHeader />
          <main className="flex-1 overflow-y-auto bg-muted p-4 md:p-6">
            <QueryErrorResetBoundary>
              {({ reset }) => (
                <ErrorBoundaryGroup>
                  <ErrorBoundary onReset={reset} fallback={PageErrorFallback}>
                    <Outlet />
                  </ErrorBoundary>
                </ErrorBoundaryGroup>
              )}
            </QueryErrorResetBoundary>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
